import '@/modules/card';
import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);

export default class ProductCarouselArticle {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * product carousel article element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.init();
    }

    init() {
        new Swiper(this.sliderElement, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            threshold: 10,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                1024: {
                    spaceBetween: 18
                }
            }
        });
    }
}
